import React, { useState, Fragment, useCallback, useEffect } from 'react';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import { update, loadError } from '../Actions/Cart.action';
import { reloadPayment } from '../Actions/Checkout.action';
import CartProductQuantity from  '../Components/Checkout.CartProductQuantity'

const Cart = () => {
    const dispatch = useDispatch();
    const [removingRow, setRemovingRow] = useState({});
    const cart = useSelector((state) => state.cart);
    const [orderRows, setOrderRows] = useState(cart?.orderRows);
    const { payload, checkoutMode } = useSelector((state) => state.checkout);
    const [usedDiscountCodes, setUsedDiscountCodes] = useState(payload.usedDiscountCodes);

    useEffect(() => {
        setOrderRows(cart?.orderRows);
    }, [cart]);

    useEffect(() => {
        setUsedDiscountCodes(payload?.usedDiscountCodes)
    }, [payload])

    const removeOrderRow = useCallback(
        (articleNumber) =>
            dispatch(update(articleNumber, 0)).then(() =>
                dispatch(reloadPayment())
            ),
        [dispatch]
    );

    const ProductImage = useCallback(({ order }) => {
        return (
            <img
                className="cart-row__image"
                src={order.image}
                alt={order.name}
            />
        );
    }, []);

    const ProductName = useCallback(({ order }) => {
        return (
            <Fragment>
                {order.brand && (
                    <div className="cart-row__brand-name">
                        {order.brand}
                    </div>
                )}
                <a className="cart-row__product-name" href={order.url}>
                    {order.publicName}
                </a>
                {order.weight > 0 && (
                    <div className="cart-row__product-unit">
                        {order.weight} {order.unit}
                    </div>
                )}
            </Fragment>
        );
    }, []);

    const ProductPrice = useCallback(({ order }) => {
        const unitString = `/ ${translate('checkout.cart.unit')}`

        return (
            <div className="cart-row__price-wrapper">
                <div className="cart-row__price">
                    { order.campaignPrice &&
                        <div className="cart-row__campaign-price">
                            {order.campaignPrice}
                        </div>
                    }
                    
                    <span className="cart-row__original-price">
                        <span className="cart-row__price-text">
                            {order.price}&nbsp;
                        </span>
                        {unitString}
                    </span>
                </div>
                <div className="cart-row__compare-price">
                    {translate('comparingPriceText')}<span>: </span>
                    {order.comparingPrice}
                </div>
            </div>
        );
    }, []);

    const ProductTotalPrice = ({ order }) => {
        return (
            <div className="cart-row__total-price-wrapper">
                <div className="cart-row__total-price-text">
                    {translate('checkout.cart.total')}
                </div>
                <div className="cart-row__total-price">
                    {order.totalCampaignPrice || order.totalPrice}
                </div>
            </div>
        );
    };

    const RemoveBtn = useCallback(
        ({ order }) => {
            return (
                <Fragment>
                    {!order.isFreeGift && !removingRow[order.rowSystemId] && (
                        <button
                            className="table__icon table__icon--delete"
                            onClick={() =>
                                setRemovingRow({
                                    ...removingRow,
                                    [order.rowSystemId]: true,
                                })
                            }
                            title={translate('general.remove')}
                        ></button>
                    )}
                    {!order.isFreeGift && removingRow[order.rowSystemId] && (
                        <Fragment>
                            <button
                                className="table__icon table__icon--accept"
                                onClick={() =>
                                    removeOrderRow(order.articleNumber)
                                }
                                title={translate('general.ok')}
                            ></button>
                            <button
                                className="table__icon table__icon--cancel"
                                onClick={() =>
                                    setRemovingRow({
                                        ...removingRow,
                                        [order.rowSystemId]: false,
                                    })
                                }
                                title={translate('general.cancel')}
                            ></button>
                        </Fragment>
                    )}
                </Fragment>
            );
        },
        [removeOrderRow, removingRow]
    );

    const ProductQuantity = useCallback(({ order }) => {
        const websiteText = translate('product.maxorderquantity');
        const text = websiteText.replace('{}', order.maxOrderQuantity)
        return (
            <div className={"cart-row__quantity-wrapper " + (order.maxOrderQuantity > 0 ? "cart-row__quantity-wrapper--limit" : '')}>
                <CartProductQuantity order={order} />
                {order.maxOrderQuantity > 0 && (
                    <div className="cart-row__quantity-limit">
                        {text}
                    </div>
                )}
            </div>
        );
    }, []);

    return (
        <Fragment>
            {orderRows.map((order) => (
                <div
                    className="row small-unstack no-margin cart-row"
                    key={order.rowSystemId}
                >
                    <a className="cart-row__image-wrapper" href={order.url}>
                        <ProductImage order={order} />
                    </a>
                    <div className="cart-row__product-info">
                        <ProductName order={order} />
                    </div>
                    <div className="cart-row__checkout-prices">
                        <ProductPrice order={order} />
                    </div>
                    <div className="cart-row__product-quantity">
                        <ProductQuantity order={order} />
                    </div>
                    <div className="cart-row__prices">
                        <ProductPrice order={order} />
                        <ProductTotalPrice order={order} />
                    </div>
                    <div className="cart-row__remove">
                        <RemoveBtn order={order} />
                    </div>
                </div>
            ))}
        </Fragment>
    );
};

export default Cart;
